module.exports = __webpack_public_path__ + "img/10-Judge-02.88c6bbc3.jpg";